import { ColorPickerModule } from 'ngx-color-picker';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MppColorPickerComponent } from './color-picker.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, ColorPickerModule],
  declarations: [MppColorPickerComponent],
  exports: [MppColorPickerComponent],
})
export class MppColorPickerModule {}
